import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Category } from '../models/category.model';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {
  private http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/categories`;
  private cache$: Observable<Category[]> | null = null;

  getCategories(): Observable<Category[]> {
    if (!this.cache$) {
      this.cache$ = this.http.get<Category[]>(this.apiUrl).pipe(
        shareReplay(1)
      );
    }
    return this.cache$;
  }

  clearCache(): void {
    this.cache$ = null;
  }
}
